export const focusElement = (suffix: string, index: number | string): void => {
  const elem = document.querySelector(`[data-${suffix}='${index}']`)
  if (elem) {
    ;(elem as HTMLElement).focus()
  }
}
